<template>
    <table :class="{ inverse: inverse }">
        <tbody>
            <tr v-for="(item, index) in value">
                <td>{{ item.text }}</td>
                <td>{{ item.value }}</td>
            </tr>
        </tbody>
        <tfoot v-if="footerItem">
            <tr>
                <td colspan="2">
                    <span class="item-text">{{ footerItem.text }}</span>
                    <div class="text-editor-output" v-html="footerItem.value" />
                </td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
    export default {
        name: 'DataList',
        props: {
            value: Array,
            footerItem: Object,
            inverse: Boolean
        }
    }
</script>

<style lang="scss" scoped>
    table {
        width: 100%;
        font-size: rem(14px);
        table-layout: fixed;

        tbody {
            tr:nth-child(odd) {
                background: rgba(255, 255, 255, 0.1);
            }

            td {
                padding: 4px 12px;
                white-space: pre-line;
                font-size: rem(14px);
                line-height: rem(20px);
            }
        }

        tfoot {
            td {
                padding: 18px 6px 6px;

                .item-text {
                    color: $color-grey-4;
                }

                p {
                    margin: 3px 0 0;
                }
            }
        }

        &.inverse {
            tbody tr:nth-child(odd) {
                background: $color-grey-11;
            }
        }
    }
</style>
